import { Box, Chip, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ClinicalNotesContextDataType } from '../../pages/clinical-notes-page/clinical-notes.context';

export type DiagnosisSelectChipsProps = {
  selectedDiagnoses: ClinicalNotesContextDataType['diagnoses'];
  onDiagnosisRemove: (diagnosisId: string) => void;
  className?: string;
};

export const DiagnosisSelectedChips: React.VFC<DiagnosisSelectChipsProps> = ({
  selectedDiagnoses,
  onDiagnosisRemove,
  className
}) => {
  const { classes, cx } = useStyles();

  return (
    <Box display="flex" gap="1rem" flexWrap="wrap">
      {selectedDiagnoses.map(({ code, name, id }) => {
        const label = <Typography className={classes.label}>{`${code} ${name}`}</Typography>;

        return (
          <Chip
            className={cx(classes.chip, className)}
            label={label}
            key={id}
            onDelete={() => onDiagnosisRemove(id)}
          />
        );
      })}
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  chip: {
    borderRadius: 0,
    color: theme.palette.text.primary,
    background: theme.palette.grey[200],
    maxWidth: '100%',
    whiteSpace: 'normal',
    height: 'auto',
    padding: theme.spacing(0.75),
  },
  label: {
    fontSize: 'inherit',
    whiteSpace: 'normal'
  }
}));
